"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coinsToGetFromPyth = void 0;
exports.getMultiLatestPrices = getMultiLatestPrices;
exports.fetchRequiredPrices = fetchRequiredPrices;
exports.getLatestPrices = getLatestPrices;
exports.getLatestTokenPricePairs = getLatestTokenPricePairs;
const index_js_1 = require("../index.js");
const simpleCache_js_1 = require("./simpleCache.js");
const latestPriceCache = new simpleCache_js_1.SimpleCache(5000);
exports.coinsToGetFromPyth = [
    "SUI/USD",
    "USDC/USD",
    "USDT/USD",
    "HASUI/USD",
    "CETUS/USD",
    "VSUI/USD",
    "NAVX/USD",
    "SCA/USD",
    "AFSUI/USD",
    "WETH/USD",
    "WBTC/USD",
    "TURBOS/USD",
    "CELO/USD",
    "SLP/USD",
    "SOL/USD",
    "APT/USD",
    "BUCK/USD",
    "WSOL/USD",
    "WUSDC/USD",
    "ALPHA/USD",
    "FUD/USD",
    "BLUB/USD",
    "ETH/USD",
    "DEEP/USD",
    "AUSD/USD",
    "USDY/USD",
    "NS/USD",
    "BLUE/USD",
    "SEND/USD",
    "STSUI/USD",
    "SUIUSDT/USD",
    "SUIBTC/USD",
    "LBTC/USD",
    "WAL/USD",
    "MUSD/USD",
];
async function getMultiLatestPrices() {
    const pricesFromPyth = await getLatestPrices(exports.coinsToGetFromPyth, true);
    pricesFromPyth.forEach((price, index) => {
        if (price) {
            const cacheKey = `getLatestPrice-${exports.coinsToGetFromPyth[index]}`;
            latestPriceCache.set(cacheKey, price);
        }
    });
}
async function fetchRequiredPrices() {
    const apiUrl = "https://api.alphalend.xyz/public/graphql";
    const query = `
    query {
      coinInfo {
        coinType
        coingeckoPrice
        pythPrice
      }
    }`;
    const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ query }),
    });
    const dataArr = (await response.json()).data.coinInfo;
    const priceMap = {};
    for (const data of dataArr) {
        let coinType = data.coinType;
        let coin;
        if (coinType.startsWith("0x0")) {
            coinType = "0x" + coinType.substring(3);
        }
        coin = Object.keys(index_js_1.coinsList).find((coinKey) => index_js_1.coinsList[coinKey].type === coinType);
        if (data.coinType === "0x2::sui::SUI") {
            coin = "SUI";
        }
        if (!coin || (!data.coingeckoPrice && !data.pythPrice)) {
            // console.error(`Coin not found for coinType: ${data.coinType}`);
            continue;
        }
        if (data.pythPrice) {
            priceMap[coin] = data.pythPrice.toString();
        }
        else {
            priceMap[coin] = data.coingeckoPrice.toString();
        }
    }
    return priceMap;
}
async function getLatestPrices(pairs, ignoreCache) {
    let requireCall = false;
    const prices = pairs.map((pair) => {
        const cacheKey = `getLatestPrice-${pair}`;
        if (ignoreCache) {
            latestPriceCache.delete(cacheKey);
        }
        const cachedResponse = latestPriceCache.get(cacheKey);
        if (cachedResponse) {
            return cachedResponse;
        }
        requireCall = true;
        return pair;
    });
    if (requireCall) {
        try {
            const priceMap = await fetchRequiredPrices();
            for (let i = 0; i < prices.length; i++) {
                const entry = prices[i];
                if (entry.includes("/USD")) {
                    const coinName = entry.toString().split("/")[0];
                    const price = priceMap[coinName] ? priceMap[coinName] : "0";
                    const cacheKey = `getLatestPrice-${entry}`;
                    latestPriceCache.set(cacheKey, price);
                    prices[i] = price;
                }
            }
        }
        catch {
            console.error("couldnt fetch prices");
        }
    }
    return prices;
}
async function getLatestTokenPricePairs(pairs, ignoreCache) {
    const priceMap = {};
    // Use getLatestPrices to fetch all prices at once
    const prices = await getLatestPrices(pairs, ignoreCache);
    pairs.forEach((pair, index) => {
        priceMap[pair] = prices[index];
    });
    return priceMap;
}
// interface PythPricePair {
//   pair: PythPriceIdPair;
//   price: string;
// }
// async function fetchPricesFromAlphaAPI(
//   pairs: PythPriceIdPair[],
// ): Promise<PythPricePair[]> {
//   const req_url = `https://api.alphafi.xyz/alpha/fetchPrices?pairs=${pairs.join(",")}`;
//   let prices: PythPricePair[] = [];
//   try {
//     const res = await fetch(req_url);
//     if (!res.ok) {
//       throw new Error(`HTTP error! status: ${res.status}`);
//     }
//     const data = (await res.json()) as PythPricePair[];
//     prices = data;
//   } catch (error) {
//     console.error(`Error fetching prices for pairs ${pairs}:`, error);
//     throw error;
//   }
//   return prices;
// }
//# sourceMappingURL=prices.js.map